import React from 'react';
import { ProductList } from 'views';

const OnSale = () => {
  return <ProductList onSale={true} />
}

export default OnSale;
